import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { isAuthenticated } from "../utilities/auth";
import React, { lazy, Suspense, useEffect, useState } from "react";
import EscBackHandler from "pages/authorized/wallet/EscBackHandler";

// Lazy load routes
const PrivateRoutes = lazy(() => import("./privateRoutes"));
const PublicRoutes = lazy(() => import("./publicRoutes"));
const SplaceScreen = lazy(() => import("../pages/splaceScreen"));

const AppRoutes = () => {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1000);

    return () => clearTimeout(timer); // cleanup
  }, []);

  return (
    <Router>
      <EscBackHandler />
      <Suspense fallback={<SplaceScreen />}>
        {showSplash ? (
          <SplaceScreen />
        ) : (
          <Routes>
            {isAuthenticated() ? (
              <Route path="/*" element={<PrivateRoutes />} />
            ) : (
              <Route path="/*" element={<PublicRoutes />} />
            )}
          </Routes>
        )}
      </Suspense>
    </Router>
  );
};

export default AppRoutes;
